export default function handCevent(eventType, params) {
    var CountEvent = window.JAnalyticsInterface.Event.CountEvent;
    var cEvent = new CountEvent(eventType);
    params && params.forEach(e => {
        cEvent.addKeyValue(e.key, e.value)
    });
    console.log(cEvent, 'cEventcEvent');
    window.JAnalyticsInterface.onEvent(cEvent);
}


// WEBPACK FOOTER //
// ./resources/js/components/cEvent.js